/**
 * The Translation (EN) cell — one implementation for every grid (TZ §12).
 *
 * ★ Text is rendered ONLY for status "translated". That is the whole rule, and
 * it is enforced here rather than trusted from the payload: "identical" is a
 * third of the corpus, so a cell that echoed the original would leave the user
 * with a column repeating the one beside it on every third row — visibly worse
 * than having no column at all. The backend already nulls `text` for those
 * statuses; this makes the guarantee independent of it.
 *
 * Everything that is not "translated" or "pending" renders EMPTY, not "—":
 * "identical", "english_local", "failed", an absent field and an unreachable
 * service must be indistinguishable. A translation is a reference attribute
 * (§1) and its absence is never an error the user is shown.
 */

type Props = {
  status?: string | null;
  text?: string | null;
};

export function TranslationValue({ status, text }: Props) {
  if (status === "pending") {
    // §12 — a placeholder while the §12 poll fills it in. aria-hidden: it
    // carries no information a screen reader can use, and the cell it sits in
    // may well end up empty.
    return <span className="tl-skel" aria-hidden="true" />;
  }
  if (status === "translated" && text) return <>{text}</>;
  return null;
}

export function TranslationCell({ status, text }: Props) {
  return (
    <td className="tl-cell">
      <TranslationValue status={status} text={text} />
    </td>
  );
}
